import React from "react"

function toBoolean(value: string) {
	return value.trim().toLowerCase() === "true"
}

export const Flag = {
	TARIFFS: toBoolean(import.meta.env.VITE_FLAG_TARIFFS || "false"),
	ECOMM_SERVICE_DISPATCH: toBoolean(import.meta.env.VITE_FLAG_ECOMM_SERVICE_DISPATCH || "false"),
	VITE_FLAG_ECOMM_FREIGHT: toBoolean(import.meta.env.VITE_FLAG_ECOMM_FREIGHT || "false"),
	VITE_PDP_DOCUMENTS_FLAG: toBoolean(import.meta.env.VITE_PDP_DOCUMENTS_FLAG || "false"),
	VITE_FLAG_HIDE_TRENDING: toBoolean(import.meta.env.VITE_FLAG_HIDE_TRENDING || "false"),
}

type FeatureFlagProps = {
	old?: React.ReactElement
	children?: React.ReactElement
	flag: boolean
}

export const isFeatureFlagOn = (flag: boolean) => {
	return flag || !!localStorage["F&F"]
}

export const FeatureFlag: React.FC<FeatureFlagProps> = ({ children, old, flag }) => {
	const component = flag || localStorage["F&F"] ? children : old
	return component ?? null
}

export const useFeatureFlag = (flag: boolean, oldComponent: React.FC, newComponent: React.FC) => {
	return flag || localStorage["F&F"] ? newComponent : oldComponent
}

export const useIsFeatureFlagOn = (flag: boolean) => {
	return flag || localStorage["F&F"]
}
